import { Inject, Injectable } from '@angular/core';
import { API_URL } from '@frontend-site/shared/data';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { PDialogService } from '@frontend-site/ui/components';
import { Recommendation } from '@frontend-site/recommendations/domain';
import { MaintenanceDialogComponent } from '../maintenance-dialog/maintenance-dialog';

@Injectable({ providedIn: 'root' })
export class MaintenanceService {
    constructor(
        @Inject(API_URL) private readonly apiUrl: string,
        private http: HttpClient,
        private $translate: TranslateService,
        private dialog: PDialogService
    ) {}

    showMaintenanceRecommendation(recommendation: Recommendation) {
        const contextParameters = JSON.parse(recommendation.contextParameters);
        const config = {
            panelClass: 'p-dialog-small',
            data: { contextParameters: contextParameters, dontShowAgain: recommendation.dontShowAgain }
        };
        this.dialog
            .open(MaintenanceDialogComponent, config)
            .afterClosed()
            .subscribe((dialogData) => {
                if (dialogData) {
                    this.updateDontShowAgainRecommendation(recommendation);
                }
            });
    }

    updateDontShowAgainRecommendation(recommendation: Recommendation) {
        const payload = {
            recommendationId: recommendation.recommendationId,
            dontShowAgain: recommendation.dontShowAgain,
            accountId: recommendation.accountId
        };
        this.http.post(`${this.apiUrl}/pqm/updateDontShowAgainRecommendation`, payload).subscribe();
    }
}
